import React, { Component } from 'react';

class ErrorIcon extends Component {
	render() {
		return (
			<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor">
				<path d="M24.406 22.747c0.091-0.147 0.099-0.331 0.022-0.485l-7.982-15.963c-0.17-0.338-0.723-0.338-0.893 0l-7.982 15.963c-0.077 0.155-0.069 0.338 0.022 0.485s0.251 0.236 0.425 0.236h15.963c0.173 0 0.333-0.090 0.425-0.236zM16 20.49c-0.275 0-0.499-0.224-0.499-0.499s0.223-0.499 0.499-0.499 0.499 0.224 0.499 0.499-0.224 0.499-0.499 0.499zM16.499 17.995c0 0.275-0.223 0.499-0.499 0.499s-0.499-0.224-0.499-0.499v-5.487c0-0.275 0.223-0.499 0.499-0.499s0.499 0.223 0.499 0.499v5.487z"></path>
				<path d="M16 1.533c-8.252 0-14.966 6.714-14.966 14.966 0 4.588 2.114 8.782 5.809 11.588l-0.737 1.105c-0.096 0.144-0.111 0.327-0.038 0.484s0.22 0.266 0.392 0.287l3.991 0.499c0.021 0.003 0.041 0.004 0.062 0.004 0.166 0 0.322-0.082 0.415-0.222 0.105-0.157 0.112-0.36 0.018-0.524l-1.995-3.492c-0.086-0.15-0.243-0.245-0.416-0.251-0.171-0.012-0.337 0.078-0.432 0.222l-0.704 1.057c-3.414-2.616-5.366-6.506-5.366-10.757 0-7.702 6.266-13.968 13.968-13.968s13.968 6.266 13.968 13.968c0 5.463-3.214 10.456-8.188 12.72-0.251 0.114-0.362 0.41-0.247 0.66 0.084 0.184 0.265 0.292 0.454 0.292 0.069 0 0.139-0.014 0.206-0.045 5.33-2.425 8.773-7.775 8.773-13.628 0-8.252-6.714-14.966-14.966-14.966z"></path>
			</svg>
		)
	}
}

export default ErrorIcon;


// WEBPACK FOOTER //
// ./src/components/icons/ErrorIcon.js